module.exports = "//\n// Errors\n//\n\nBiwaScheme.Error = BiwaScheme.Class.create({\n  initialize: function(msg){\n    this.message = \"Error: \"+msg;\n  },\n  toString: function(){\n    return this.message;\n  }\n});\n\nBiwaScheme.Bug = BiwaScheme.Class.extend(new BiwaScheme.Error(), {\n  initialize: function(msg){\n    this.message = \"[BUG] \"+msg;\n  }\n});\n\n// currently used by \"raise\"\nBiwaScheme.UserError = BiwaScheme.Class.extend(new BiwaScheme.Error(), {\n  initialize: function(msg){\n    this.message = msg;\n  }\n});\n\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/biwascheme/src/system/error.js
// module id = 43
// module chunks = 0